class GopuffBreinify {
  constructor() {
    this.recommendations = [];
    this.groupCounter = 0;
    this.timeoutDelay = 250;
    this.customEventName = `gopuffBreinify::GroupedResultsReady`;
    this.fetchResults = this.fetchResults.bind(this);
  }

  resetRecommendations() {
    this.recommendations = [];
  }

  addRecommendation(recommendationParams) {
    this.recommendations = [...this.recommendations, recommendationParams];

    this.fetchGroupedResults();
  }

  async fetchGroupedResults() {
    const recommendations = [...this.recommendations];

    if (this.recommendations.length === 3) {
      this.resetRecommendations();
    }

    const groupedResults = await this.fetchGroupedResultsHelper(recommendations);

    if (!groupedResults) { return; }
    
    window.dispatchEvent(new CustomEvent(this.customEventName, {
      detail: {
        queries: recommendations.map(JSON.stringify),
        results: groupedResults,
      },
    }));

    return groupedResults;
  }

  fetchGroupedResultsHelper(recommendations) {
    this.groupCounter++;
    const groupCounter = this.groupCounter;

    return new Promise(async (resolve) => {
      if (recommendations.length === 3) {
        const results = await this.fetchResults(recommendations);
  
        return resolve(results);
      }

      this.timeout = setTimeout(async () => {
        if (this.groupCounter !== groupCounter) { return resolve(); }

        const results = await this.fetchResults(recommendations);

        return resolve(results);
      }, this.timeoutDelay);
    });
  }

  async retry(callback, attempts = 10, attempt = 1, ...callbackArgs) {
    if (attempt > attempts) { return; }
  
    const result = await callback(...callbackArgs);
  
    if (result) { return result; }
    
    return await new Promise((resolve) => {
      setTimeout(async () => {
        const data = await this.retry(callback, attempts, attempt + 1, ...callbackArgs);
    
        return resolve(data);
      }, 100);
    }); 
  };

  initBreinify() {
    if (window.Breinify) { return window.Breinify; }
    
    // loaded via script earlier
  
    return false;
  }

  getBreinifyRecommendationData(recommendations = []) {
    return new Promise(async (resolve, reject) => {
      try {
        await (this.retry(this.initBreinify));

        Breinify.recommendation({}, recommendations, function(data, errorText) {
          if (data) {
            return resolve(data);
          } else {
            return reject(errorText);
          }
        });
      } catch (error) {
        console.error(`failed to load breinify recommendations`, error);
        
        return reject(error);
      }
    })
  }

  async fetchResults(recommendations = []) {
    try {
      const data = await this.getBreinifyRecommendationData(recommendations);

      if (!data.results) { return []; }

      return data.results || [];
    } catch (err) {
      return [];
    }
  }

  async getRecommendations(recommendationParams) {
    return new Promise((resolve, reject) => {
      if (!recommendationParams) { return reject(); }
  
      this.addRecommendation(recommendationParams);
  
      const callback = (event) => {
        const { results, queries } = event.detail;
        const foundQuery = queries.find((query) => {
          return query === JSON.stringify(recommendationParams);
        });

        if (!foundQuery) { return; }

        const index = queries.indexOf(foundQuery);
        const recommendations = results[index];

        if (!recommendations) { return; }

        window.removeEventListener(this.customEventName, callback);

        if (!(recommendations.statusCode && recommendations.statusCode === 200)) {
          console.log(`error getting recommendations`, recommendations.message);

          return resolve({
            result: [],
            additionalData: {},
          });
        }

        return resolve(recommendations);
      };

      window.addEventListener(this.customEventName, callback);
    });
  }
}

window.gopuffBreinify = new GopuffBreinify();